function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgaChecklist = function SvgaChecklist(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Checklist' : _ref$title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, rest, {
    viewBox: "0 0 26 26"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6875 2.97684L18.6127 24.375L0.40625 24.3094L0.489892 0.40625L16.2289 0.462916",
    fill: "white"
  }), React.createElement("path", {
    d: "M0.34002 0L16.341 0.0564314L16.3392 0.561784L0.592189 0.506028L0.508849 23.8051L18.5104 23.8688L18.5856 2.81174L19.0938 2.81354L19.0177 24.1232C19.0172 24.2546 18.9161 24.3621 18.7872 24.3739L18.7627 24.375L0.253183 24.3096C0.12111 24.3092 0.0129306 24.2086 0.0010762 24.0804L0 24.0561L0.0850343 0.251779C0.0855035 0.120439 0.186656 0.0128597 0.315546 0.00107037L0.34002 0Z",
    fill: "#333333"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6875 2.84375L16.25 2.83506L16.2587 0.40625L18.6875 2.84375Z",
    fill: "white"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 2.59569L16.2585 0.238388C16.2592 0.025668 16.5176 -0.0799422 16.6679 0.071012L19.0237 2.43675C19.174 2.5877 19.0663 2.84451 18.8529 2.84375L16.4886 2.83531C16.3564 2.83484 16.2495 2.72756 16.25 2.59569ZM18.2764 2.36427L16.7351 0.816399L16.7295 2.3587L18.2764 2.36427Z",
    fill: "#333333"
  }), React.createElement("path", {
    d: "M6.90804 6.5L13.4062 6.51774L13.4045 6.90625L6.90625 6.88851L6.90804 6.5Z",
    fill: "#333333"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6832 7.3125L4.46875 7.3082L4.47323 6.09375L5.6875 6.09805L5.6832 7.3125Z",
    fill: "#A0D467"
  }), React.createElement("path", {
    d: "M6.90804 8.9375L13.4062 8.95524L13.4045 9.34375L6.90625 9.32601L6.90804 8.9375Z",
    fill: "#333333"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6832 9.75L4.46875 9.7457L4.47323 8.53125L5.6875 8.53555L5.6832 9.75Z",
    fill: "#A0D467"
  }), React.createElement("path", {
    d: "M6.90804 11.375L13.4062 11.3927L13.4045 11.7812L6.90625 11.7635L6.90804 11.375Z",
    fill: "#333333"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6832 12.1875L4.46875 12.1832L4.47323 10.9688L5.6875 10.9731L5.6832 12.1875Z",
    fill: "#A0D467"
  }), React.createElement("path", {
    d: "M6.90804 14.2188L13.4062 14.2365L13.4045 14.625L6.90625 14.6073L6.90804 14.2188Z",
    fill: "#333333"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6832 15.0312L4.46875 15.0269L4.47323 13.8125L5.6875 13.8168L5.6832 15.0312Z",
    fill: "#A0D467"
  }), React.createElement("path", {
    d: "M6.90804 16.6562L13.4062 16.674L13.4045 17.0625L6.90625 17.0448L6.90804 16.6562Z",
    fill: "#333333"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6832 17.4688L4.46875 17.4644L4.47323 16.25L5.6875 16.2543L5.6832 17.4688Z",
    fill: "#A0D467"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5938 19.2969C25.5938 22.7745 22.7745 25.5938 19.2968 25.5938C15.8191 25.5938 13 22.7745 13 19.2969C13 15.8192 15.8191 13 19.2968 13C22.7745 13 25.5938 15.8192 25.5938 19.2969Z",
    fill: "white"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5938 19.2969C12.5938 15.5948 15.5948 12.5938 19.2968 12.5938C22.9988 12.5938 26 15.5949 26 19.2969C26 22.9989 22.9988 26 19.2968 26C15.5948 26 12.5938 22.9989 12.5938 19.2969ZM25.4901 19.2969C25.4901 15.8765 22.7172 13.1036 19.2967 13.1036C15.8762 13.1036 13.1034 15.8764 13.1034 19.2969C13.1034 22.7174 15.8762 25.4903 19.2967 25.4903C22.7172 25.4903 25.4901 22.7174 25.4901 19.2969Z",
    fill: "#333333"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7812 19.5C24.7812 22.4167 22.4167 24.7812 19.5 24.7812C16.5833 24.7812 14.2188 22.4167 14.2188 19.5C14.2188 16.5833 16.5833 14.2188 19.5 14.2188C22.4167 14.2188 24.7812 16.5833 24.7812 19.5Z",
    fill: "#51C1E9"
  }), React.createElement("path", {
    d: "M22.3875 17.4688L22.75 17.8063L19.319 21.5312L17.0625 19.5958L17.3831 19.2178L19.2786 20.8437L22.3875 17.4688Z",
    fill: "#333333"
  }));
};

SvgaChecklist = pure(SvgaChecklist);
SvgaChecklist.displayName = 'SvgaChecklist';
export default SvgaChecklist;